import AssemblyMaterials from './AssemblyMaterials';

export default AssemblyMaterials;